"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaintenanceBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var portal_core_1 = require("@ferry/portal-core");
var MaintenanceBannerWidget = /** @class */ (function (_super) {
    __extends(MaintenanceBannerWidget, _super);
    function MaintenanceBannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showBanner: false
        };
        return _this;
    }
    MaintenanceBannerWidget.prototype.render = function () {
        return (this.state.showBanner &&
            (0, jsx_runtime_1.jsxs)("div", { className: "banner journey-content mb-3", children: [(0, jsx_runtime_1.jsx)("img", { src: "/img/alert-orange.svg", alt: "Orange alert icon" }), (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: (0, jsx_runtime_1.jsxs)("p", { children: ["On ", (0, jsx_runtime_1.jsx)("b", { children: this.state.bannerDay }), " between ", (0, jsx_runtime_1.jsx)("b", { children: this.state.bannerTime }), " you may find that you\u2019re unable to get a new ", portal_core_1.resourcesHelper.THEME_NAME, " quote. If your quote is unsuccessful please try again after this time. Thanks for your patience."] }) })] }));
    };
    return MaintenanceBannerWidget;
}(React.Component));
exports.MaintenanceBannerWidget = MaintenanceBannerWidget;
//# sourceMappingURL=MaintenanceBannerWidget.js.map